<template>
	<navigation-select ref="navigation" :title="title" :subtitle="subtitle">
		<navigation-button @click="onAccount_ClickHandler" route="UserProfileAccount" routeStartsWith="UserProfileAccount" :title="$t('base.profile.account_information')" />
		<navigation-button @click="onSubscriptions_ClickHandler" route="UserProfileSubscriptions" routeStartsWith="UserProfileSubscriptions" :title="$t('labels.general.subscriptions')" />
		<navigation-button @click="onBudget_ClickHandler" route="UserProfileBudget" routeStartsWith="UserProfileBudget" :title="$t('labels.general.budget')" />
		<navigation-button @click="onNotifications_ClickHandler" route="UserProfileNotifications" routeStartsWith="UserProfileNotifications" :title="$t('base.profile.notifications')" />
		<navigation-button @click="onOrganizations_ClickHandler" route="UserProfileOrganizations" routeStartsWith="UserProfileOrganizations" :title="$t('labels.general.organization')" />
		<navigation-button @click="onStaff_ClickHandler" route="UserProfileStaff" routeStartsWith="UserProfileStaff" :title="$t('base.profile.staff')" />
		<navigation-button @click="onLocale_ClickHandler" route="UserProfileLocale" routeStartsWith="UserProfileLocale" :title="'Locale'" />
	</navigation-select>
</template>

<script>
import { mapGetters } from 'vuex'
import NavigationButton from '@/components/navigation/NavigationButton'
import NavigationSelect from '@/components/navigation/NavigationSelect'
export default {
	name: 'user-profile-navigation',
	components: {
		NavigationButton,
		NavigationSelect
	},
	data() {
		return {
			subtitle: 'Account'
		}
	},
	computed: {
		title() {
			if (this.$route.name.startsWith('UserProfileSubscriptions'))
				return this.$t('labels.general.subscriptions')
			if (this.$route.name.startsWith('UserProfileBudget'))
				return this.$t('labels.general.budget')
			if (this.$route.name.startsWith('UserProfileNotifications'))
				return this.$t('base.profile.notifications')
			if (this.$route.name.startsWith('UserProfileOrganizations'))
				return this.$t('labels.general.organization')
			if (this.$route.name.startsWith('UserProfileStaff'))
				return this.$t('base.profile.staff')
			if (this.$route.name.startsWith('UserProfileLocale'))
				return this.$t('Locale')
			return this.$t('base.profile.account_information')
		},
		navigation() {
			return this.$refs.navigation
		},
		...mapGetters({
			currentUser: 'CURRENT_USER'
		})
	},
	methods: {
		onAccount_ClickHandler() {
			this.gotAction('UserProfileAccount')
			this.navigation.close()
		},
		onSubscriptions_ClickHandler() {
			this.gotAction('UserProfileSubscriptions')
			this.navigation.close()
		},
		onBudget_ClickHandler() {
			this.gotAction('UserProfileBudget')
			this.navigation.close()
		},
		onNotifications_ClickHandler() {
			this.gotAction('UserProfileNotifications')
			this.navigation.close()
		},
		onOrganizations_ClickHandler() {
			this.gotAction('UserProfileOrganizations')
			this.navigation.close()
		},
		onStaff_ClickHandler() {
			this.gotAction('UserProfileStaff')
			this.navigation.close()
		},
		onLocale_ClickHandler() {
			this.gotAction('UserProfileLocale')
			this.navigation.close()
		},
		gotAction(route) {
			this.$router.push({
				name: route,
				params: {
					user_uid: this.currentUser.uid
				}
			})
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/user/UserProfileNavigation.vue